module.exports = __webpack_public_path__ + "media/img/home/directions/direction1-4c8a23a49a87f9fac764076f5c8fb756.svg";